<template>
  <div class="app-layout">
    <Sidebar />
    <main class="main-content">
      <Header />
      <router-view v-slot="{ Component }">
        <transition name="fade" mode="out-in">
          <component :is="Component" />
        </transition>
      </router-view>
      <footer class="site-footer">
        <div class="footer-content">
          <span>© 2026 天天读书 Nav Portal</span>
          <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">
            京ICP备2026008120号-1
          </a>
        </div>
      </footer>
    </main>
    <CommandPalette ref="commandPaletteRef" />
    <AIAssistant ref="aiAssistantRef" />
  </div>
</template>

<script setup>
import { onMounted, ref, provide } from 'vue'
import { useNavStore } from '@/stores/nav'
import Sidebar from '@/components/Sidebar.vue'
import Header from '@/components/Header.vue'
import CommandPalette from '@/components/CommandPalette.vue'
import AIAssistant from '@/components/AIAssistant.vue'

const navStore = useNavStore()
const commandPaletteRef = ref(null)
const aiAssistantRef = ref(null)

// Header 与这两个弹窗组件是兄弟关系，provide 必须放在共同父组件 App 中
provide('openCommandPalette', () => commandPaletteRef.value?.open())
provide('openAIAssistant', () => aiAssistantRef.value?.open())

onMounted(() => {
  navStore.init()
})
</script>
